import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

/*
 * Hairline tags (Archived, Approved, Revoked, Expired): 20px, 1px control
 * border, 4px radius, 11.5px/500, no fill. Counts are not badges.
 */
const badgeVariants = cva(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-xs border border-line-2 bg-transparent px-1.5 text-[11.5px] leading-none font-medium whitespace-nowrap text-fg-2 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "",
        secondary: "",
        destructive: "text-danger",
        outline: "",
        ghost: "border-transparent px-0 text-fg-3",
        link: "border-transparent px-0 text-link underline-offset-[3px] hover:underline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant = "default",
  render,
  ...props
}: useRender.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return useRender({
    defaultTagName: "span",
    props: mergeProps<"span">(
      {
        className: cn(badgeVariants({ variant }), className),
      },
      props,
    ),
    render,
    state: {
      slot: "badge",
      variant,
    },
  });
}

export { Badge, badgeVariants };
